import React, { useState, useEffect, useRef } from "react";
import { apiCallGeneric } from "../../service/api-service.js";
import { ReactComponent as ArrowDownIcon } from "../../assets/svg/drop-down-arrow.svg";
import { ReactComponent as ArrowUpIcon } from "../../assets/svg/arrow-up.svg";

const CustomDropdownWithSearch = ({
  searchId = -1,
  onChangeIndex = {},
  onDropdownChange,
  apiUrl,
  placeholder,
  selectedValue,
  selectedOption,
  params = {},
  disabled = false
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [options, setOptions] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dropdownRef = useRef(null);

  const fetchOptions = async () => {
    setLoading(true);
    setError(null);
    try {
      if (apiUrl) {
        const queryParams = { ...params, term: searchTerm };
        const queryString = new URLSearchParams(queryParams).toString();
        const baseUrl = apiUrl.split('?')[0];
        const fullUrl = `${baseUrl}${baseUrl.includes("?") ? "&" : "?"}${queryString}`;
        
        const response = await apiCallGeneric("get", fullUrl);

        if (response!==undefined && response.status === 200 && response.data.success === true) {
          console.log(apiUrl);
          setOptions(response.data.suggestionlist);
          setFilteredOptions(response.data.suggestionlist);
          console.log("response.data.suggestionlist")
          console.log(response.data.suggestionlist)
        } else {
          setOptions([]);
          setFilteredOptions([]);
        }
      }
    } catch (err) {
      console.error("Error fetching options:", err);
      setError("No options found.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOptions();
  }, [searchTerm]);

  useEffect(() => {
    if (searchTerm === "") {
      setFilteredOptions(options);
    } else {
      setFilteredOptions(
        options.filter((option) =>
          option.label.toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }
  }, [searchTerm, options]);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    if (disabled) return; // ✅ prevent dropdown from opening
    setIsOpen((prev) => !prev);
    if (!isOpen) {
      fetchOptions();
    }
  };

  const selectOption = (option) => {
    if (Object.keys(onChangeIndex).length === 0) {
      onDropdownChange(option);
    } else {
      onDropdownChange(option, onChangeIndex);
    }
    setIsOpen(false);
  };

  return (
    <div ref={dropdownRef} style={{ position: "relative", height: "40px" }}>
      {/* Dropdown Header */}
      <div
        onClick={toggleDropdown}
        style={{
          height: "40px",
          padding: "10px",
         /*  border: isOpen ? "1px solid #6929E2" : "1px solid #E5E5E5", */
          borderRadius: "8px",
          cursor: disabled ? "not-allowed" : "pointer", // ✅ update cursor
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          background: "transparent" /* disabled ? "#f5f5f5" : "#FFFFFF" */, // ✅ update background
          color: disabled ? "#B0B0B0" : selectedOption || (selectedValue !== "") ? '#3B84E6' : '#3B84E6',
          fontSize: "14px",
          fontWeight: "500"
        }}
      >
        <span style={{ textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
          {selectedOption ? selectedOption.label : (selectedValue != null && selectedValue !== "") ? selectedValue : placeholder}
        </span>
        <span style={{ marginLeft: "10px" }}>{isOpen ? <ArrowDownIcon /> : <ArrowDownIcon />}</span>
      </div>

      {/* Dropdown Options */}
      {isOpen && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            border: "1px solid #ccc",
            borderRadius: "4px",
            background: "#fff",
            zIndex: 1000,
            maxHeight: "200px",
            overflowY: "auto",
            width:'250px'
          }}
        >
          {/* Search Input */}
          {/* {filteredOptions.length > 1 && ( */}
      <input
        type="text"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder="Search..."
        disabled={disabled}
        style={{
          width: "100%",
          padding: "8px",
          border: "none",
          borderBottom: "1px solid #E5E5E5",
          boxSizing: "border-box",
          color: "#334155",
          background: disabled ? "#f5f5f5" : "#fff"
        }}
      />
    {/* )} */}

          {/* Options */}
          {loading ? (
            <div style={{ padding: "10px", textAlign: "center" }}>Loading...</div>
          ) : error ? (
            <div style={{ padding: "10px", textAlign: "center", color: "red" }}>
              {error}
            </div>
          ) : filteredOptions && filteredOptions.length > 0 ? (
            filteredOptions.map((option, index) => (
              <div
                key={index}
                onClick={() => selectOption(option)}
                style={{
                  padding: "10px",
                   width:'250px',
                  cursor: "pointer",
                  background:
                    selectedOption && selectedOption.value === option.value
                      ? "#f0f0f0"
                      : "#fff",
                  color: "#3B84E6",
                  textAlign: "left",
                  fontSize:'14px'
                }}
              >
                {option.label}
              </div>
            ))
          ) : (
            <div style={{ padding: "10px", textAlign: "center" }}>
              No records found.
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CustomDropdownWithSearch;















// import React, { useState, useEffect, useRef } from "react";
// import axios from 'axios';
// import { ReactComponent as ArrowDownIcon } from "../../../assets/svg/arrow-down.svg";
// import { ReactComponent as ArrowUpIcon } from "../../../assets/svg/arrow-up.svg";
// import { getCookie } from '../../getcookie.js';

//     const CustomDropdownWithSearch = ({searchId=-1,onChangeIndex={}, onDropdownChange, apiUrl, placeholder, selectedValue,selectedOption,params={} }) => {
//       const [isOpen, setIsOpen] = useState(false);
//       const [searchTerm, setSearchTerm] = useState("");
//       const [options, setOptions] = useState([]);
//       const [filteredOptions, setFilteredOptions] = useState([]);
//      /*  const [selectedOption, setSelectedOption] = useState(null); */
//       const [loading, setLoading] = useState(false);
//       const [error, setError] = useState(null);
//       const dropdownRef = useRef(null);
    
//       const getQueryParamsAsObject = (url) => {
//         const urlObj = new URL(url);
//         const params = new URLSearchParams(urlObj.search);
//         return Object.fromEntries(params.entries()); // Convert to object
//       };

//       // Mock API call to fetch options
//       const fetchOptions = async () => {
//         setLoading(true);
//         setError(null);
//         try {
//           if(apiUrl!==undefined && apiUrl!==""){
//            /*  const paramsFromUrl=getQueryParamsAsObject(apiUrl); */
          
//             params["term"]=searchTerm;
//            await axios.get(apiUrl.split('?')[0], {
//             params: params??{},
//             headers: {
//                 'Content-Type': 'application/json; charset=UTF-8',
//                 "Accept": "application/json",
        
//                 "Access-Control-Allow-Origin": "*", // Required for CORS support to work
//                  "Authorization":getCookie("mawalog")
//               }
//           }).then((response) => {
//             if(response.status===200){
//                 if (response.data.success === true) {
                 
//           setOptions(response.data.suggestionlist); 
//           setFilteredOptions(response.data.suggestionlist);                 
//                 }else{
//                   setOptions([]); 
//                   setFilteredOptions([]);  
//                 }
//             }
//           });
    
        
//         }
//         } catch (err) {
//           console.error("Error fetching options:", err);
//           setError("No options found.");
//         } finally {
//           setLoading(false);
//         }
//       };
    
//       // Fetch options when component mounts or search term changes
//       useEffect(() => {
//         fetchOptions();
//       }, [searchTerm]);
    
//       // Filter options based on search term
//       useEffect(() => {
//         if (searchTerm === "") {
//           setFilteredOptions(options);
//         } else {
//           setFilteredOptions(
//             options.filter((option) =>
//               option.label.toLowerCase().includes(searchTerm.toLowerCase())
//             )
//           );
//         }
//       }, [searchTerm, options]);
    
//       // Handle outside click to close the dropdown
//       const handleClickOutside = (event) => {
//         if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//           setIsOpen(false);
//         }
//       };
    
//       useEffect(() => {
//         document.addEventListener("mousedown", handleClickOutside);
//         return () => {
//           document.removeEventListener("mousedown", handleClickOutside);
//         };
//       }, []);
    
//       const toggleDropdown = () =>{
//          setIsOpen((prev) => !prev);
//          if(!isOpen){
//           fetchOptions();
//          }
//          }
    
//       const selectOption = (option) => {
//         /* setSelectedOption(option); */
//         console.log('on select....',onChangeIndex)
//         if(Object.keys(onChangeIndex).length===0){
//           onDropdownChange(option);
//         }else{
//           onDropdownChange(option, onChangeIndex);
//         }
        
//         setIsOpen(false);
//       };
    
//       return (
//         <div ref={dropdownRef} style={{ position: "relative",  height:"40px" }}>
//           {/* Dropdown Header */}
//           <div
//             onClick={toggleDropdown}
//             style={{
//               height:"40px",
//               padding: "10px",
//               border: isOpen?"1px solid #6929E2":"1px solid #E5E5E5",
//               borderRadius: "8px",
//               cursor: "pointer",
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               background: "#FFFFFF",
//               color:selectedOption || (selectedValue!=="") ?'#1E1E1E':'#81878C',
//               fontSize: "14px",
//               fontWeight: "500"
//             }}
//           >
//            <span style={{ textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden",}}> {selectedOption ? selectedOption.label :(selectedValue!=null && selectedValue!=="")?selectedValue: placeholder }</span>
//             <span style={{ marginLeft: "10px" }}>{isOpen ? <ArrowUpIcon/> : <ArrowDownIcon/>}</span>
//           </div>
    
//           {/* Dropdown Options */}
//           {isOpen && (
//             <div
//               style={{
//                 position: "absolute",
//                 top: "100%",
//                 left: 0,
//                 right: 0,
//                 border: "1px solid #ccc",
//                 borderRadius: "4px",
//                 background: "#fff",
//                 zIndex: 1000,
//                 maxHeight: "200px",
//                 overflowY: "auto",
//               }}
//             >
//               {/* Search Input */}
//               <input
//                 type="text"
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 placeholder="Search..."
//                 style={{
//                   width: "100%",
//                   padding: "8px",
//                   border: "none",
//                   borderBottom: "1px solid #ccc",
//                   boxSizing: "border-box",
//                   color:'#1E1E1E'
//                 }}
//               />
    
//               {/* Options */}
//               {loading ? (
//                 <div style={{ padding: "10px", textAlign: "center" }}>Loading...</div>
//               ) : error ? (
//                 <div style={{ padding: "10px", textAlign: "center", color: "red" }}>
//                   {error}
//                 </div>
//               ) : filteredOptions.length > 0 ? (
//                 filteredOptions.map((option, index) => (
//                   <div
//                     key={index}
//                     onClick={() => selectOption(option)}
//                     style={{
//                       padding: "10px",
//                       cursor: "pointer",
//                       background:
//                         selectedOption && selectedOption.id === option.id
//                           ? "#f0f0f0"
//                           : "#fff",
//                           color:'#1E1E1E',
//                            textAlign: "left"
//                     }}
//                   >
//                     {option.label}
//                   </div>
//                 ))
//               ) : (
//                 <div style={{ padding: "10px", textAlign: "center" }}>
//                   No records found.
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//       );
//     };
    
//     export default CustomDropdownWithSearch;
  